import { defineMessages } from 'react-intl';

export default defineMessages({
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.baseVictorsMedicalTugo.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  thisSectionRelatedToMedicalExpenses: {
    id: 'fastCover.baseVictorsMedicalTugo.thisSectionRelatedToMedicalExpenses',
    defaultMessage: 'This section relates to medical expenses such as doctor visits, prescriptions or hospitalizations that were incurred in Canada.',
  },

  // Checkbox 1: Doctor's Visit
  checkboxDoctorVisit: {
    id: 'fastCover.baseVictorsMedicalTugo.checkboxDoctorVisit',
    defaultMessage: "Doctor's Visit",
  },
  questionFirstVisitIllnessAccident: {
    id: 'fastCover.baseVictorsMedicalTugo.questionFirstVisitIllnessAccident',
    defaultMessage: 'Is this the your first visit for this illness or accident?',
  },
  headerOutpatientPhysicianFees: {
    id: 'fastCover.baseVictorsMedicalTugo.headerOutpatientPhysicianFees',
    defaultMessage: 'Outpatient Physician Fees',
  },
  questionFollowUpVisit: {
    id: 'fastCover.baseVictorsMedicalTugo.questionFollowUpVisit',
    defaultMessage: 'Is this a follow up visit for a previously claimed illness or accident other than a fracture?',
  },
  questionFollowUpVisitFracture: {
    id: 'fastCover.baseVictorsMedicalTugo.questionFollowUpVisitFracture',
    defaultMessage: 'Is this a follow up visit for a fracture?',
  },
  headerFollowUpVisit: {
    id: 'fastCover.baseVictorsMedicalTugo.headerFollowUpVisit',
    defaultMessage: 'Follow Up Visit',
  },
  messageNoOngoingCare: {
    id: 'fastCover.baseVictorsMedicalTugo.messageNoOngoingCare',
    defaultMessage: 'We do not cover visits for ongoing care. Please refer to your policy document for further detail.',
  },

  // Checkbox 2: Diagnostic Tests
  checkboxDiagnosticTests: {
    id: 'fastCover.baseVictorsMedicalTugo.checkboxDiagnosticTests',
    defaultMessage: 'Diagnostic Tests',
  },
  headerDiagnosticTests: {
    id: 'fastCover.baseVictorsMedicalTugo.headerDiagnosticTests',
    defaultMessage: 'Diagnostic Tests',
  },

  // Checkbox 3: Prescription Drugs
  checkboxPrescriptionDrugs: {
    id: 'fastCover.baseVictorsMedicalTugo.checkboxPrescriptionDrugs',
    defaultMessage: 'Prescription Drugs',
  },
  headerPrescriptionDrugs: {
    id: 'fastCover.baseVictorsMedicalTugo.headerPrescriptionDrugs',
    defaultMessage: 'Prescription Drugs',
  },

  // Checkbox 4: Ambulance Services
  checkboxAmbulanceServices: {
    id: 'fastCover.baseVictorsMedicalTugo.checkboxAmbulanceServices',
    defaultMessage: 'Ambulance Services',
  },
  questionGroundAmbulance: {
    id: 'fastCover.baseVictorsMedicalTugo.questionGroundAmbulance',
    defaultMessage: 'Is your invoice for a ground ambulance?',
  },
  headerGroundAmbulance: {
    id: 'fastCover.baseVictorsMedicalTugo.headerGroundAmbulance',
    defaultMessage: 'Ground Ambulance',
  },
  questionAirAmbulance: {
    id: 'fastCover.baseVictorsMedicalTugo.questionAirAmbulance',
    defaultMessage: 'Is your invoice for an air ambulance?',
  },
  headerAirAmbulance: {
    id: 'fastCover.baseVictorsMedicalTugo.headerAirAmbulance',
    defaultMessage: 'Air Ambulance',
  },

  // Checkbox 5: Hospitalization
  checkboxHospitalization: {
    id: 'fastCover.baseVictorsMedicalTugo.checkboxHospitalization',
    defaultMessage: 'Hospitalization',
  },
  questionHospitalInvoice: {
    id: 'fastCover.baseVictorsMedicalTugo.questionHospitalInvoice',
    defaultMessage: 'Is your invoice from the hospital?',
  },
  headerHospitalFees: {
    id: 'fastCover.baseVictorsMedicalTugo.headerHospitalFees',
    defaultMessage: 'Hospital Fees',
  },
  questionPhysicianInvoice: {
    id: 'fastCover.baseVictorsMedicalTugo.questionPhysicianInvoice',
    defaultMessage: 'Is your invoice from the physician?',
  },
  headerInpatientPhysicianFees: {
    id: 'fastCover.baseVictorsMedicalTugo.headerInpatientPhysicianFees',
    defaultMessage: 'Inpatient Physician Fees',
  },
  questionLabDiagnosticFacility: {
    id: 'fastCover.baseVictorsMedicalTugo.questionLabDiagnosticFacility',
    defaultMessage: 'Is your invoice from a lab or other diagnostic facility (xrays, bloodwork, etc)?',
  },
  headerXrayLabsOtherDiagnostics: {
    id: 'fastCover.baseVictorsMedicalTugo.headerXrayLabsOtherDiagnostics',
    defaultMessage: 'Xray, Labs, or other diagnostics',
  },
  questionOtherHospitalizationRelated: {
    id: 'fastCover.baseVictorsMedicalTugo.questionOtherHospitalizationRelated',
    defaultMessage: 'Is your invoice from something else directly related to your hospitalization?',
  },
  headerXrayLabsOtherDiagnosticsOther: {
    id: 'fastCover.baseVictorsMedicalTugo.headerXrayLabsOtherDiagnosticsOther',
    defaultMessage: 'Xray, Labs, or other diagnostics',
  },

  // Common fields
  displayExpenseBoxIncluding: {
    id: 'fastCover.baseVictorsMedicalTugo.displayExpenseBoxIncluding',
    defaultMessage: 'Display expense box including:',
  },
  descriptionOfExpense: {
    id: 'fastCover.baseVictorsMedicalTugo.descriptionOfExpense',
    defaultMessage: 'Description of expense',
  },
  dateOfExpense: {
    id: 'fastCover.baseVictorsMedicalTugo.dateOfExpense',
    defaultMessage: 'Date of expense',
  },
  amountClaimed: {
    id: 'fastCover.baseVictorsMedicalTugo.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  providerName: {
    id: 'fastCover.baseVictorsMedicalTugo.providerName',
    defaultMessage: 'Provider Name',
  },
  providerDetail: {
    id: 'fastCover.baseVictorsMedicalTugo.providerDetail',
    defaultMessage: 'Provider Detail',
  },
  currency: {
    id: 'fastCover.baseVictorsMedicalTugo.currency',
    defaultMessage: 'Currency',
  },

  // Common responses
  yes: {
    id: 'fastCover.baseVictorsMedicalTugo.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.baseVictorsMedicalTugo.no',
    defaultMessage: 'No',
  },
  isRequired: {
    id: 'fastCover.baseVictorsMedicalTugo.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  addItem: {
    id: 'fastCover.baseVictorsMedicalTugo.addItem',
    defaultMessage: 'Add Expense',
  },
  itemWithIdx: {
    id: 'fastCover.baseVictorsMedicalTugo.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },
  expenseFor: {
    id: 'fastCover.baseVictorsMedicalTugo.expenseFor',
    defaultMessage: 'Expense For',
  },
  selectInsuredForExpense: {
    id: 'fastCover.baseVictorsMedicalTugo.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },

  // Essential Medical Appliances
  checkboxEssentialMedicalAppliances: {
    id: 'fastCover.baseVictorsMedicalTugo.checkboxEssentialMedicalAppliances',
    defaultMessage: 'Essential Medical Appliances',
  },
  tooltipEssentialMedicalAppliances: {
    id: 'fastCover.baseVictorsMedicalTugo.tooltipEssentialMedicalAppliances',
    defaultMessage: 'Expenses related to the cost of renting essential medical equipment such as crutches or wheelchair.',
  },
  headerEssentialMedicalAppliances: {
    id: 'fastCover.baseVictorsMedicalTugo.headerEssentialMedicalAppliances',
    defaultMessage: 'Essential Medical Appliances',
  },

  // Private Duty Nursing
  checkboxPrivateDutyNursing: {
    id: 'fastCover.baseVictorsMedicalTugo.checkboxPrivateDutyNursing',
    defaultMessage: 'Private Duty Nursing',
  },
  tooltipPrivateDutyNursing: {
    id: 'fastCover.baseVictorsMedicalTugo.tooltipPrivateDutyNursing',
    defaultMessage: 'Private duty nursing must be performed by an RN other than a family member when ordered in writing by the attending physician.',
  },
  headerPrivateDutyNursing: {
    id: 'fastCover.baseVictorsMedicalTugo.headerPrivateDutyNursing',
    defaultMessage: 'Private Duty Nursing',
  },

  // Fracture Treatment
  checkboxFractureTreatment: {
    id: 'fastCover.baseVictorsMedicalTugo.checkboxFractureTreatment',
    defaultMessage: 'Fracture Treatment',
  },
  tooltipFractureTreatment: {
    id: 'fastCover.baseVictorsMedicalTugo.tooltipFractureTreatment',
    defaultMessage: 'Expenses related to fracture treatment including casting, splinting, and related medical procedures.',
  },
  headerFractureTreatment: {
    id: 'fastCover.baseVictorsMedicalTugo.headerFractureTreatment',
    defaultMessage: 'Fracture Treatment',
  },
  selectInsureds: {
    id: 'fastCover.selectInsureds',
    defaultMessage: 'Select Insured(s)',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.BaseVictorsMedical/messages.js